import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
// import {Actions} from '../AppConstants';
import {BsModalRef, BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {ColDef, ColGroupDef, GridOptions} from "ag-grid-enterprise";
import {IffShipmentSummaryService} from "../../../services/iff-shipment-summary/iff-shipment-summary.service";
import {AlertService} from "../../../services/alert/alert.service";
import {ActivatedRoute} from "@angular/router";
import {Actions} from "../../../shared/common-components/AppConstants";
import {LoadingService} from "../../../services/loading/loading.service";


@Component({
    selector: 'app-pay-shipment-invoices-modal',
    templateUrl: './pay-shipment-invoices-modal.component.html',
    styleUrls: ['./pay-shipment-invoices-modal.component.css'],
    standalone: false
})
export class PayShipmentInvoicesModalComponent implements OnInit {
  selectedNodes: any;
  question = 'Please confirm the selected AF payment(s) identified below and the corresponding "Total Amount to be Paid."  Select "Next" to continue or "Go Back" to modify your selection(s).';
  showGrid = true;
  title = 'AF Payment Confirmation';
  confirmText = 'Next';
  cancelText = 'Go back';
  gridOptions: GridOptions = this.initializeGridOptions();
  columnDefs: (ColDef | ColGroupDef)[];
  public overlayNoRowsTemplate;
  private gridApi;
  totalAmount;
  iffMasterIds;

  @Output()
  emitData: EventEmitter<any> = new EventEmitter();

  makeSelection(confirm: any) {
    this.bsModalRef.hide();
  }

  constructor(public bsModalRef: BsModalRef, private modalService: BsModalService, private alert: AlertService,private route: ActivatedRoute,
              public options: ModalOptions, private iffShipmentSummaryService: IffShipmentSummaryService, private loader: LoadingService) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display.</span>';
  }

  ngOnInit() {
    this.selectedNodes = this.options.initialState.selectedNodes;
    this.totalAmount = (this.selectedNodes.reduce((sum, obj) => sum + Number(obj.totalIFF), 0)).toFixed(2);
    this.iffMasterIds = this.selectedNodes.map(x => x.iffMasterId)
    console.log(this.totalAmount)
    this.updateColumnDefs();
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.selectedNodes,
      headerHeight: 30,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  updateColumnDefs() {
    this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
  }

  getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'SCAC Code',
          field: 'scac',
          filter: 'agTextColumnFilter',
          sortable: true,
          cellRenderer: 'agGroupCellRenderer'
        },
      {
        headerName: 'Move Type',
        field: 'moveType',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Type of Transportation',
        field: 'transportationType',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Reporting Year',
        field: 'reportingYear',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Reporting Quarter',
        field: 'reportingQuarter',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        headerName: 'Total AF',
        field: 'totalIFF',
        filter: 'agTextColumnFilter',
        sortable: true,
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      }
    ];
  }

  /**
   * initializing the ag-grid
   * @param params
   */
  onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }

  onNextClick(): void {
    this.title = 'Redirecting to Pay.gov';
    this.question = 'By choosing "Next" you will be redirected to Pay.gov to complete your transaction.  Once finished, you will be returned to TMSS 2.0.  Choose "Go Back" to modify your selection(s).'
    this.showGrid = false;
  }

  onFinalNextClick(): void {
    this.bsModalRef.hide();
    this.loader.show();
    const payload = {
      iffMasterIds: this.iffMasterIds,
      totalAmount: this.totalAmount
    }
    this.iffShipmentSummaryService.getPaygovToken(payload).subscribe((res: string) => {
      this.loader.hide();
      this.bsModalRef.hide();
      window.location.replace(res);
    }, error => {
      this.loader.hide();
      this.bsModalRef.hide();
      this.alert.error('Error while connecting to paygov gateway. Please contact administrator');
    })

  }

}
